// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ASK_AN_EXPERT = "Poradny";
export const FORUM = "F\u00f3ra";
